import { createFileRoute } from '@tanstack/react-router';
import { AdminQuotesPage } from '@/features/admin/admin-quotes-page';

export const Route = createFileRoute('/sales/quotes/')({
  component: SalesQuotesIndexRoute,
});

function SalesQuotesIndexRoute() {
  return <AdminQuotesPage actionHrefBase="/sales/quotes" portalBase="/sales" />;
}
